import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import FavoriteButtonComponent from './component'

export const Favorite = combine(
  withTableController({ id: 'favorite-beneficiaries-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withCallback(
    'onFavoriteButton',
    ({ followerService, table }, { value }) =>
      () => {
        followerService
          .removeFollowers({ beneficiaryIds: [value.beneficiaryDTO.id] })
          .then(() => table.refresh())
      },
    ['value']
  )
)(FavoriteButtonComponent)
